/**
 * @desc 通过Redis插入审批信息
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.test.insertApproverInfo.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/insertApproverInfo`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
